import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";

import { environment } from '../../../../environments/environment';
import { LoanService } from "../loan.service";
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';

@Injectable({
  providedIn: 'root'
})
export class PrintdemandsheetService {

  constructor(private loanService: LoanService,
    private datePipe: DatePipe) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  GenerateReport(demandsheetData: any) {
    let searchDate = new Date(demandsheetData.LoanToDate);
    this.loanService.FetchReportsDemandSheet(demandsheetData)
      .toPromise()
      .then(data => {
        if (data.length > 0) {
          this.ReportGenerateList(data, this.datePipe, demandsheetData.IsCentreORCustomerWise,searchDate);
        }
        else {
          console.log('data not found!');
        }
      })
      .catch(err => { console.log(err) });
  }

  ReportGenerateList(demandSheet, datePipe: DatePipe,IsCentreORCustomerWise :number,searchDate : Date) {

    var generateData = function (demandSheet, IsCentreORCustomer) {

      var result = [];
      var itemData = [{}];
      let nullstring = 0;
      let NameField : string;
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < demandSheet.length; i += 1) {

        if(IsCentreORCustomer = 1) {
          NameField = demandSheet[i].CentreName.toString();
        }
        else{
          NameField =  demandSheet[i].CentreName.toString();
        }
        
        itemData[i] = {
          Id: demandSheet[i].Id.toString(),
          // 'Centre':  demandSheet[i].CentreName.toString(),
          'Name':  NameField.toString(),
          'Loan': demandSheet[i].LoanDemand.toString() ,
          'Savings': demandSheet[i].SavingsDemand.toString(),
          'Total': ((demandSheet[i].LoanDemand * 1) + (demandSheet[i].SavingsDemand *1)).toString(),
          'Principle': demandSheet[i].PrincipleAmount.toString() ,
          'Interest': demandSheet[i].InterestAmount.toString() ,
          // 'SAvings': demandSheet[i].SavingsPrinciple.toString(),
          // 'TOtal': ((demandSheet[i].PrincipleAmount *1) + (demandSheet[i].InterestAmount *1) 
          //             + (demandSheet[i].SavingsPrinciple * 1)) .toString(),
          'SAvings': demandSheet[i].SavingsDemand.toString(),
          'TOtal': ((demandSheet[i].PrincipleAmount *1) + (demandSheet[i].InterestAmount *1) 
                      + (demandSheet[i].SavingsDemand * 1)) .toString(),
          'Loan Prepaid': demandSheet[i].LoanPrepaid.toString(),
          'Savings Prepaid': demandSheet[i].SavingsPrepaid.toString(),
          'Prepaid Total' : ((demandSheet[i].LoanPrepaid * 1) + (demandSheet[i].SavingsPrepaid * 1 )).toString(),
          'Loan OverDue': demandSheet[i].LoanOverDue.toString(),
          'Savings OverDue':  demandSheet[i].SavingsOverDue.toString(),
          'OverDue Total' : ((demandSheet[i].LoanOverDue * 1) + (demandSheet[i].SavingsOverDue * 1 )).toString(),
        };
      }

      // 'Date': datePipe.transform(LoanList[i].LoanApprovedDate, 'dd-MM-yyyy'),

      for (var i = 0; i < demandSheet.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 86,
          align: "left",
          padding: 0,
        });
      }
      return HeaderResult;
    }

    var headers = createHeaders([
      "Id",
      "Name",
      "Loan",
      "Savings",
      "Total",
      "Principle",
      "Interest",
      "SAvings",
      "TOtal",
      "Loan Prepaid",
      "Savings Prepaid",
      "Prepaid Total",
      "Loan OverDue", 
      "Savings OverDue" ,
      "OverDue Total",   
    ]);

    // Document of 210mm wide and 297mm high
    // new jsPDF('p', 'mm', [297, 210]);
    // // Document of 297mm wide and 210mm high
    // new jsPDF('l', 'mm', [297, 210]);
    // // Document of 5 inch width and 3 inch high
    // new jsPDF('l', 'in', [3, 5]);

    // let pdf = new jsPDF('l', 'pt', 'legal');    
    // let pdf = new jsPDF('l', 'pt', 'letter');
    // let pdf = new jsPDF('p', 'pt', 'A4');
    let pdf = new jsPDF('l', 'pt', 'legal');
    //   let pdf = new JsPDF(  
    //     Orientation, // Landscape or Portrait     
    //     unit, // mm, cm, in     
    //     format // A2, A4 etc  
    // );  

    pdf.setProperties({
      title: 'Demand Sheet',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });
    
    // let todayDate = new Date(); 
      
    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(15);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 420, 40);  // 40 is the height
    pdf.text("Demand Sheet as on " + datePipe.transform(searchDate, 'dd-MM-yyyy') , 420, 60);

    pdf.setLineWidth(1.5);
    pdf.line(5, 80, 999, 80)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');

    // pdf.text("Approved As :" + demandSheet[0].CentreName.toString(), 25, 120);
    // pdf.text("Centre      :" + demandSheet[0].CentreName.toString(), 25, 140);
    // pdf.text("Status      :" + demandSheet[0].LoanApprovedStatus.toString(), 440, 120);
    // pdf.text("Branch      :" + demandSheet[0].CustomerBranchName.toString(), 440, 140);
    // pdf.line(5, 150, 590, 150)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
    // doc.table(1, 1, generateData(100), headers, { autoSize: true });

    // Body
    pdf.table(5, 105, generateData(demandSheet, IsCentreORCustomerWise), headers, { autoSize: false });
    // pdf.output('dataurlnewwindow');  // commented on 20-03-2026 based on blank pdf on browser.
    // doc.save('Collection.pdf');  

    // The view logic
    const blob = pdf.output('blob')
    // create a temporary URL
    const url = URL.createObjectURL(blob);
    //open in a new tab(View Mode)
    const newWindow = window.open(url, '_blank');

    //safety check for pop-up blockers
    if(!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined'){
      alert('please disable your pop-up blocker to view the PDF.')
    }

    // We use a slight delay or wait for the window to unload
    if (newWindow) {
        newWindow.onload = () => {
            // Optional: Revoke after a delay to ensure Chrome has finished rendering
            setTimeout(() => {
                URL.revokeObjectURL(url);
                console.log("Memory cleared.");
            }, 1000);
    };
    // Body End
  }
}
}
